import { useTranslations } from '../context/TranslationContext';

export const Services: React.FC = () => {
  const { t } = useTranslations();

  return (
    <section id="services" className="py-32 bg-white border-t border-hair">
      <div className="max-w-7xl mx-auto px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-20" data-reveal>
          <div className="lg:col-span-4">
            <div className="eyebrow mb-4">01 / {t.services.title}</div>
          </div>
          <div className="lg:col-span-8">
            <h2 className="display text-[42px] md:text-[56px] mb-6">{t.services.title}</h2>
            <p className="text-mute text-base leading-[1.8] max-w-2xl font-light">
              {t.services.intro}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-0">
          {t.services.items.map((service, index) => (
            <div key={index} className="hairline py-10" data-reveal>
              <div className="flex items-baseline gap-6 mb-4">
                <span className="number-tag">{String(index + 1).padStart(2, '0')}</span>
                <h3 className="display text-[28px]">{service.title}</h3>
              </div>
              <p className="text-mute text-sm leading-[1.7] mb-4 font-light">
                {service.intro}
              </p>
              <ul className="text-[13px] text-ink font-light space-y-1">
                {service.mainPoints.map((point, i) => (
                  <li key={i}>— {point}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
